<template>
  <Form ref="carRecordsForm" :model="carRecords" v-loading="loading" :disabled="actionType=='detail'"
        :rules="ruleValidate" :label-width="100">
    <input v-model="carRecords.id" type="hidden"/>

    <FormItem :label="this.$t('travel.car-records.dataId.label')" prop="dataId">
      <Input v-model="carRecords.dataId" :placeholder="$t('travel.car-records.dataId.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.plateNo.label')" prop="plateNo">
      <Input v-model="carRecords.plateNo" :placeholder="$t('travel.car-records.plateNo.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.plateColor.label')" prop="plateColor">
      <Select v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.plateColor.holder')">
        <Option v-for="item in this.dict.plate_color" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
<!--      <InputNumber v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.plateColor.holder')"/>-->
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.crossType.label')" prop="crossType">
      <Select v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.crossType.holder')">
        <Option v-for="item in this.dict.cross_type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.gate.label')" prop="gate">
      <Input v-model="carRecords.gate" :placeholder="$t('travel.car-records.gate.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.channel.label')" prop="channel">
      <Input v-model="carRecords.channel" :placeholder="$t('travel.car-records.channel.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.crossTime.label')" prop="crossTime">
      <Date-picker :value="carRecords.crossTime" @on-change="crossTimeFormat" type="datetime"
                   :placeholder="this.$t('travel.car-records.crossTime.holder')"></Date-picker>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.releaseReason.label')" prop="releaseReason">
      <Select v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.releaseReason.holder')">
        <Option v-for="item in this.dict.release_reason" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.releaseWay.label')" prop="releaseWay">
      <Select v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.releaseWay.holder')">
        <Option v-for="item in this.dict.release_way" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.releaseResult.label')" prop="releaseResult">
      <Select v-model="carRecords.plateColor" :placeholder="$t('travel.car-records.releaseResult.holder')">
        <Option v-for="item in this.dict.release_result" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.plateImg.label')" prop="plateImg">
      <Input v-model="carRecords.plateImg" :placeholder="$t('travel.car-records.plateImg.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.boxNum.label')" prop="boxNum">
      <InputNumber v-model="carRecords.boxNum" :placeholder="$t('travel.car-records.boxNum.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.box.label')" prop="box">
      <Input v-model="carRecords.box" :placeholder="$t('travel.car-records.box.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.boxIso.label')" prop="boxIso">
      <Input v-model="carRecords.boxIso" :placeholder="$t('travel.car-records.boxIso.holder')"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.boxImg.label')" prop="boxImg">
      <Input v-model="carRecords.boxImg" :placeholder="$t('travel.car-records.boxImg.holder')" type="textarea"
             :rows="3"/>
    </FormItem>

    <FormItem :label="this.$t('travel.car-records.remark.label')" prop="remark">
      <Input v-model="carRecords.remark" :placeholder="$t('travel.car-records.remark.holder')"/>
    </FormItem>

  </Form>
</template>
<script>
  import api from '@/api'

  export default {
    dictParams: ['release_way','plate_color', 'cross_type', 'release_reason','cross_result'],
    data () {
      return {
        carRecords: {
          id: null,
          dataId: null,
          plateNo: null,
          plateColor: null,
          crossType: null,
          gate: null,
          channel: null,
          crossTime: null,
          releaseReason: null,
          releaseWay: null,
          releaseResult: null,
          plateImg: null,
          boxNum: null,
          box: null,
          boxIso: null,
          boxImg: null,
          remark: null
        },
        loading: false,
        actionType: 'add'
      }
    },
    methods: {
      handleSubmit (then, error) {
        this.$refs['carRecordsForm'].validate(valid => {
          if (valid) {
            if (this.carRecords.id) {
              this.updateCarRecords(this.carRecords).then(then).error(error)
            } else {
              this.createCarRecords(this.carRecords).then(then).error(error)
            }
          } else {
            this.$Message.error(this.$t('errorText'))
            error()
          }
        })
      },
      handleReset () {
        this.carRecords.id = ''
        this.actionType = 'add'
        this.$nextTick(() => this.$refs['carRecordsForm'].resetFields())
      },
      getCarRecords (id, type) {
        this.loading = true
        this.$refs['carRecordsForm'].resetFields()
        api.travel.CarRecords.detail(id).then(data => {
          this.carRecords.id = data.id
          this.carRecords.dataId = data.dataId
          this.carRecords.plateNo = data.plateNo
          this.carRecords.plateColor = data.plateColor
          this.carRecords.crossType = data.crossType
          this.carRecords.gate = data.gate
          this.carRecords.channel = data.gate
          this.carRecords.crossTime = data.crossTime
          this.carRecords.releaseReason = data.releaseReason
          this.carRecords.releaseWay = data.releaseWay
          this.carRecords.releaseResult = data.releaseResult
          this.carRecords.plateImg = data.plateImg
          this.carRecords.boxNum = data.boxNum
          this.carRecords.box = data.box
          this.carRecords.boxIso = data.boxIso
          this.carRecords.boxImg = data.boxImg
          this.carRecords.remark = data.remark
          this.loading = false
          this.actionType = type
        }).catch(e => this.loading = false)
      },
      createCarRecords (carRecords) {
        this.loading = true
        return api.travel.CarRecords.add(carRecords)
          .then(response => {
            this.loading = false
            this.$Message.success(this.$t('successText'))
            return response
          })
          .catch(e => {
            this.loading = false
          })
      },
      updateCarRecords (carRecords) {
        this.loading = true
        return api.travel.CarRecords.update(carRecords)
          .then(response => {
            this.loading = false
            this.$Message.success(this.$t('successText'))
            return response
          })
          .catch(e => {
            this.loading = false
          })
      },
      crossTimeFormat (str, date) {
        this.carRecords.crossTime = str ? str : ''
      },
    },
    computed: {
      ruleValidate () {
        let validate = {
          dataId: [{
            type: 'string',
            required: true,
            message: this.$t('travel.car-records.dataId.required'),
            trigger: 'blur'
          }],
          plateNo: [{
            type: 'string',
            required: true,
            message: this.$t('travel.car-records.plateNo.required'),
            trigger: 'blur'
          }, { type: 'string', max: 10, message: this.$t('travel.car-records.plateNo.max'), trigger: 'blur' }],
          plateColor: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.plateColor.required'),
            trigger: 'blur'
          }],
          crossType: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.crossType.required'),
            trigger: 'blur'
          }],
          gate: [{ type: 'string', max: 10, message: this.$t('travel.car-records.gate.max'), trigger: 'blur' }],
          channel: [{ type: 'string', max: 10, message: this.$t('travel.car-records.channel.max'), trigger: 'blur' }],
          crossTime: [{ required: true, message: this.$t('travel.car-records.crossTime.required'), trigger: 'blur' }],
          releaseReason: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.releaseReason.required'),
            trigger: 'blur'
          }],
          releaseWay: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.releaseWay.required'),
            trigger: 'blur'
          }],
          releaseResult: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.releaseResult.required'),
            trigger: 'blur'
          }],
          boxNum: [{
            type: 'number',
            required: true,
            message: this.$t('travel.car-records.boxNum.required'),
            trigger: 'blur'
          }],
          box: [{ type: 'string', max: 20, message: this.$t('travel.car-records.box.max'), trigger: 'blur' }],
          boxIso: [{ type: 'string', max: 20, message: this.$t('travel.car-records.boxIso.max'), trigger: 'blur' }],
          boxImg: [{ type: 'string', max: 65535, message: this.$t('travel.car-records.boxImg.max'), trigger: 'blur' }],
          remark: [{ type: 'string', max: 100, message: this.$t('travel.car-records.remark.max'), trigger: 'blur' }]
        }
        if (this.actionType == 'edit') {
          this.$refs['carRecordsForm'].fields.forEach(f => {
            if (f.$children[0].disabled) {
              delete validate[f.prop]
            }
          })
        } else if (this.actionType == 'detail') {
          return {}
        }
        return validate
      }
    }
  }
</script>
